<template>
  <div class="flex items-center gap-8">
    <div class="flex-1 border-bgr-300 border-t"></div>
    <div v-if="withText" class="text-bgr-300 uppercase text-sm">
      {{ t(`${trPrefix}or`) }}
    </div>
    <div v-if="withText" class="flex-1 border-bgr-300 border-t"></div>
  </div>
</template>

<script lang="ts" setup>
const { t } = useI18n()
const trPrefix = 'www.components.ui.WebccOrDivider.'

const props = withDefaults(
  defineProps<{
    withText: boolean
  }>(),
  {
    withText: false,
  },
)

const { withText } = toRefs(props)
</script>

<style></style>
